import { render, staticRenderFns } from "./ListItemRemoveButton.vue?vue&type=template&id=886b66e8&"
import script from "./ListItemRemoveButton.vue?vue&type=script&lang=js&"
export * from "./ListItemRemoveButton.vue?vue&type=script&lang=js&"
import style0 from "./ListItemRemoveButton.vue?vue&type=style&index=0&id=886b66e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports